export default __webpack_public_path__ + "static/wpLandingAdPageBgNew-7d004af14184c21f42c77eb59274b41b.png";